<template>
    <div class="admin-register-component container">
        <div v-if="!confirmPhoneScreen" class="register-form-wrapper">
            <h4 class="register-box-title">
                {{ $t("register.createAccount") }}
            </h4>
            <div class="register-form-inner row pt-4">
                <div class="register-choice col-12">
                    <div class="can-toggle mb-4">
                        <input id="register-choice-label" type="checkbox" v-model="choiceToggled" />

                        <label for="register-choice-label">
                            <div class="can-toggle__switch">
                                <div class="before text-left pl-3 py-2 pointer">
                                    <span class="choice-side-label">I'm a </span>
                                    <span class="choice-main-label d-block">
                                        {{ choiceToggled ? generalOptions.user_role_name : 'Client' }}
                                    </span>
                                </div>

                                <div class="after text-left pl-3 py-2 selected-choice pointer" :style="getStyle()">
                                    <span class="choice-side-label">I'm a </span>
                                    <span class="choice-main-label d-block">
                                        {{ choiceToggled ? 'Client' : generalOptions.user_role_name }}
                                    </span>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
                <form class="col-12">
                    <div v-if="!choiceToggled && referralCode" class="row my-3">
                        <div class="col-12 input-wrapper">
                            <span v-if="referralCode && referralCodeChecked" class="field-valid-icon">
                                <i v-if="referralCodeValid" class="fa fa-check field-valid"></i>
                                <i v-if="!referralCodeValid" class="fa fa-times field-invalid"></i>
                            </span>
                            <input v-on:keyup.enter="onRegister" v-on:keyup="checkReferralCode"
                                class="col-12 w-100 pl-3 " v-model="referralCode" type="text" name="referral_code"
                                placeholder="Have a referral code?" />
                            <span class="input-stripe-border"></span>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12 input-wrapper">
                            <input class="col-12 w-100 pl-3" :class="nameError ? 'error' : ''" v-model="name" type="text"
                                name="name" :placeholder="nameError ? nameErrorMessage : 'First Name & Last Name'"
                                @input="clearError('name')" @keyup.enter="onRegister" />
                            <span v-if="!nameError" class="input-stripe-border"></span>
                            <span v-if="nameError" class="input-stripe-border-red"></span>

                        </div>
                    </div>
                    <div v-if="!choiceToggled" class="row my-3">
                        <div class="col-12 input-wrapper">
                            <input v-on:keyup.enter="onRegister" class="col-12 w-100 pl-3" v-model="business_name"
                                type="text" name="business_name" placeholder="Business Name (Optional)" />
                            <span class="input-stripe-border"></span>
                        </div>
                    </div>
                    <div v-if="!choiceToggled && professions.length > 1" class="row my-3">
                        <div class="col-12">
                            <select class="form-select w-100" v-model="selectedProfession"
                                :class="{ grey_text: !selectedProfession }">
                                <option :value="0" disabled selected>What is your profession?</option>
                                <option v-for="(profession, index) in professions" :key="index" :value="profession">
                                    {{ profession.profession }}
                                </option>
                            </select>

                            <!-- Border indicators -->
                            <span v-if="!selectedProfessionError" class="input-stripe-border"></span>
                            <span v-if="selectedProfessionError" class="input-stripe-border-red"></span>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12">
                            <input class="col-12 w-100 pl-3" :class="emailError ? 'error' : ''" v-model="email"
                                type="email" name="email"
                                :placeholder="emailError ? emailErrorMessage : 'E-mail Address'"
                                @input="clearError('email')" @keyup.enter="onRegister" />
                            <span v-if="!emailError" class="input-stripe-border"></span>
                            <span v-if="emailError" class="input-stripe-border-red"></span>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12">
                            <input class="col-12 w-100 pl-3" :class="passwordError ? 'error' : ''" v-model="password"
                                type="password" name="password"
                                :placeholder="passwordError ? passwordErrorMessage : 'Password'"
                                @input="clearError('password')" @keyup.enter="onRegister" />
                            <span v-if="!passwordError" class="input-stripe-border"></span>
                            <span v-if="passwordError" class="input-stripe-border-red"></span>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12">
                            <div class="d-flex">
                                <div class="dropdown">
                                    <button class="btn btn-light dropdown-toggle" type="button" id="phonePrefixes"
                                        data-bs-toggle="dropdown" aria-expanded="false">

                                        {{ phone_prefix }}
                                    </button>

                                    <ul class="prefixes-dropdown dropdown-menu" aria-labelledby="phonePrefixes">
                                        <li v-for="(prefix, index) in prefixes" :key="index">
                                            <a class="dropdown-item" href="#"
                                                @click.prevent="changePhonePrefix(prefix)">
                                                {{ prefix }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div class="d-flex align-items-center justify-content-center phone-dash p-2">
                                    -
                                </div>

                                <input class="w-100 form-control" :class="phoneError ? 'error' : ''" v-model="phone"
                                    type="number" name="phone"
                                    :placeholder="phoneError ? phoneErrorMessage : 'Phone number'"
                                    @input="clearError('zip')" @keyup.enter="onRegister" />
                            </div>

                            <span v-if="!phoneError" class="input-stripe-border"></span>
                            <span v-if="phoneError" class="input-stripe-border-red"></span>
                        </div>
                        <div class="col-12 mb-2">
                            <label class="flex-label">
                                <input v-model="sms_optin" type="checkbox" name="sms-optin" :true-value="1"
                                    :false-value="0" />
                                {{ $t("register.sms_optin") }}
                            </label>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12 input-wrapper">
                            <input class="col-12 w-100 pl-3" :class="zipError ? 'error' : ''" v-model="zip" type="text"
                                name="zip" :placeholder="zipError ? zipErrorMessage : 'Zip Code'"
                                @input="clearError('zip')" @keyup.enter="onRegister" />
                            <span v-if="!zipError" class="input-stripe-border"></span>
                            <span v-if="zipError" class="input-stripe-border-red"></span>
                        </div>
                    </div>
                    <div v-if="!choiceToggled" class="row my-3">
                        <div class="col-12 input-wrapper">
                            <div :class="addressError ? 'error' : ''">
                                <GMapAutocomplete class="w-100 pl-3"
                                    :placeholder="addressError ? addressErrorMessage : 'Business Address'"
                                    @place_changed="onAddressChanged" @input="clearError('address')" />
                            </div>
                            <span v-if="!addressError" class="input-stripe-border"></span>
                            <span v-if="addressError" class="input-stripe-border-red"></span>
                        </div>
                    </div>

                    <div v-if="!choiceToggled" class="row my-3">
                        <div class="col-12">
                            <select class="form-select w-100" v-model="selectedReferralSource"
                                :class="selectedReferralSourceError ? 'error' : ''"
                                @change="clearError('selectedReferralSource')">
                                <option value="" disabled>
                                    {{ selectedReferralSourceError ? selectedReferralSourceErrorMessage : "Where did you hear about us?" }}
                                </option>

                                <option v-for="(source, index) in referralSources" :key="index" :value="source">
                                    {{ source }}
                                </option>
                            </select>

                            <!-- Border indicators -->
                            <span v-if="!selectedReferralSourceError" class="input-stripe-border"></span>
                            <span v-if="selectedReferralSourceError" class="input-stripe-border-red"></span>
                        </div>
                    </div>
                    <div v-if="!choiceToggled" class="row my-3">
                        <div class="col-12 text-center plan-select-section">
                            <div class="plan-sel-headline">
                                <span>Enjoy a FREE 7-day trial.</span>
                                <span>Then only $9.99/mo.</span>
                            </div>
                            <span>No contract, cancellation, setup, or signup fees</span>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12 text-center">
                            <button v-on:keyup.enter="onRegister" class="register-button" type="button"
                                v-on:click="onRegister" :style="getButtonStyle()">
                                Register
                            </button>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12 text-center">
                            By continuing you are indicating that you have read and agree to the
                        </div>
                        <div class="col-12 text-center">
                            <a target="_blank" href="https://www.ringmystylist.com/terms-and-condition">Terms of
                                Service</a>
                            &
                            <a target="_blank" href="https://www.ringmystylist.com/privacy-policy">Privacy Policy</a>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12 forgot-password-text text-center">
                            <span>Already have an account? </span>
                            <router-link :to="{ path: '/app/login' }">{{ $t("general.logIn") }}</router-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="confirmPhoneScreen" class="register-form-wrapper">
            <h4 class="register-box-title">Confirm Your Phone Number</h4>
            <div class="verify-phone-section form-section">
                <p>
                    To confirm the identity of your account ( associated with {{ phone }}) we sent you an SMS with a
                    validation code.
                </p>

                <div class="verifiy-code-fields text-center">
                    <input type="text" v-model="phoneCheckCode" class="phone-code-field" autocomplete="off"
                        v-on:keyup.13="checkVerificationCode" />
                </div>
                <div class="text-center">
                    <button id="check-verification-code" type="button" class="reset-password-button"
                        @click="checkVerificationCode" tabindex="10">
                        Continue
                    </button>

                    <div class="book-action-links">
                        <a class="book-action-link" href="#" @click="verifyPhoneNumber">Resend Code</a>
                        <span class="link-separator">|</span>
                        <a class="book-action-link" href="#" @click="
                            confirmPhoneScreen = false;
                        confirmedPhone = false;
                        phoneCheckCode = '';
                        ">Edit Number</a>
                    </div>
                </div>
                <div v-if="phoneCheckMessage" v-html="phoneCheckMessage"></div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import auth from "./../../services/auth.js";
import store from "./../../services/vuex.js";
import api from "../../services/apiEndpoints.js";
import eventBus from "../../services/eventBus.js";
import messages from "../../services/messages.js";

export default {
    name: "RegisterPage",
    data: function () {
        return {
            email: "",
            password: "",
            name: "",
            business_name: "",
            selectedProfession: null,
            phone: "",
            sms_optin: 0,
            zip: "",
            address: "",
            business_address_city: "",
            business_address_country: "",
            business_address_state: "",

            remember: 0,
            choiceToggled:
                window.location.hash != "#barber" &&
                window.location.hash != "#stylist" &&
                window.location.hash != "#groomer" &&
                window.location.hash != "#loctician",
            prefixes: [],
            countries: [],
            phone_prefix: "+1",
            professions: [],

            emailError: false,
            passwordError: false,
            nameError: false,
            selectedProfessionError: false,
            phoneError: false,
            zipError: false,
            addressError: false,
            subscriptionPlan: "monthly",
            referralCode: "",
            referralCodeValid: false,
            referralCodeChecked: false,
            confirmPhoneScreen: false,
            confirmedPhone: false,
            phoneCheckMessage: "",
            phoneCheckCode: "",
            referralSources: [
                "Facebook",
                "Referred by a friend",
                "Instagram",
                "Referred by my client",
                "Google",
                "App Store",
                "Other",
            ],
            selectedReferralSource: "",
            selectedReferralSourceError: "",

            // Error messages
            nameErrorMessage: '',
            emailErrorMessage: '',
            passwordErrorMessage: '',
            phoneErrorMessage: '',
            zipErrorMessage: '',
            selectedProfessionErrorMessage: '',
            selectedReferralSourceErrorMessage: '',
            addressErrorMessage: '',
        };
    },
    mounted: function () {
        if (auth.state.user) {
            this.$router.push("/app");
        }
        this.getCountries();
        this.getProfessions();

        let referral_code = this.getParameterByName("referral");

        if (referral_code) {
            this.referralCode = referral_code;
            this.choiceToggled = false;
            this.checkReferralCode();
        }

        if (this.confirmPhoneScreen) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }

        eventBus.on("user_profile_loaded", this.onRegisterSuccess);
    },
    watch: {
        choiceToggled(newVal, oldVal) {
            this.resetForm();
        }
    },
    beforeUnmount() {
        eventBus.off("user_profile_loaded", this.onRegisterSuccess);
    },
    computed: {
        selectedStylist: {
            get: function () {
                return this.$store.state.selectedStylist;
            },
            set: function (value) {
                this.$store.commit("setSelectedStylist", value);
            },
        },
    },
    methods: {
        onRegister() {
            let role = this.choiceToggled ? "client" : "stylist";

            // Validate all required fields
            const formIsValid = this.validateForm();

            // If form is invalid, stop here (fields will be highlighted automatically)
            if (!formIsValid) {
                return;
            }

            // Handle phone verification for stylist
            if (role === "stylist" && !this.confirmedPhone) {
                let d = {
                    email: this.email,
                    phone: this.phone,
                    phone_prefix: this.phone_prefix,
                };

                this.$http.post(api.actions.check_existing_user_data, d).then(
                    function (response) {
                        if (response.data.error != true) {
                            this.verifyPhoneNumber();
                        }
                    }.bind(this),
                    function () {
                        return false;
                    }
                );

                return;
            }

            // Build registration data
            let data = {
                full_name: this.name,
                email: this.email,
                password: this.password,
                role: role,
                zip: this.zip,
                phone: this.phone,
                phone_prefix: this.phone_prefix,
                sms_optin: this.sms_optin,
                app_id: this.generalOptions.app_id,
            };

            if (role === "stylist") {
                data["business_name"] = this.business_name;
                data["profession_ids"] = [this.selectedProfession.id];
                data["subscription_plan"] = this.subscriptionPlan;
                data["referral_code"] = this.referralCode;
                data["referral_source"] = this.selectedReferralSource;
                data["business_address_street"] = this.address;
                data["business_address_city"] = this.business_address_city;
                data["business_address_state"] = this.business_address_state;
                data["business_address_country"] = this.business_address_country;
            }

            // Call register
            auth.register(data);
        },
        // Simple check if field is not empty
        validateField(value) {
            return value && value.toString().trim() !== '';
        },

        // Validate all fields and set errors/messages
        validateForm() {
            // Name
            if (!this.validateField(this.name)) {
                this.nameError = true;
                this.nameErrorMessage = 'Please enter your full name';
            } else {
                this.nameError = false;
                this.nameErrorMessage = '';
            }

            // Email
            if (!this.validateField(this.email)) {
                this.emailError = true;
                this.emailErrorMessage = 'Please enter your email';
            } else {
                this.emailError = false;
                this.emailErrorMessage = '';
            }

            // Password
            if (!this.validateField(this.password)) {
                this.passwordError = true;
                this.passwordErrorMessage = 'Please enter a password';
            } else {
                this.passwordError = false;
                this.passwordErrorMessage = '';
            }

            // Phone
            if (!this.validateField(this.phone)) {
                this.phoneError = true;
                this.phoneErrorMessage = 'Please enter your phone number';
            } else {
                this.phoneError = false;
                this.phoneErrorMessage = '';
            }

            // ZIP
            if (!this.validateField(this.zip)) {
                this.zipError = true;
                this.zipErrorMessage = 'Please enter your ZIP code';
            } else {
                this.zipError = false;
                this.zipErrorMessage = '';
            }

            // Address (for stylist)
            if (!this.choiceToggled && !this.validateField(this.address)) {
                this.addressError = true;
                this.addressErrorMessage = 'Please enter your business address';
            } else {
                this.addressError = false;
                this.addressErrorMessage = '';
            }

            // Profession
            if (!this.choiceToggled && this.professions && this.professions.length > 1) {
                if (!this.validateField(this.selectedProfession)) {
                    this.selectedProfessionError = true;
                    this.selectedProfessionErrorMessage = 'Please select your profession';
                } else {
                    this.selectedProfessionError = false;
                    this.selectedProfessionErrorMessage = '';
                }
            }

            // Referral source
            if (!this.choiceToggled) {
                if (!this.validateField(this.selectedReferralSource)) {
                    this.selectedReferralSourceError = true;
                    this.selectedReferralSourceErrorMessage = 'Please select how you heard about us';
                } else {
                    this.selectedReferralSourceError = false;
                    this.selectedReferralSourceErrorMessage = '';
                }
            }

            // Return true if all fields are valid
            return !(
                this.nameError ||
                this.emailError ||
                this.passwordError ||
                this.phoneError ||
                this.zipError ||
                this.addressError ||
                this.selectedProfessionError ||
                this.selectedReferralSourceError
            );
        },
        // Reset error on input
        clearError(field) {
            this[`${field}Error`] = false;
            this[`${field}ErrorMessage`] = '';
        },
        onRegisterSuccess() {
            if (auth.state.user.role == "client" && auth.state.user.time_from_register < 10) {
                this.$router.push("/app/client-appointments-notifications");
            } else {
                this.$router.push("/app");
            }
        },
        getCountries() {
            this.$http.get(api.actions.get_countries).then(
                function (response) {
                    if (typeof response.data.countries != "undefined") {
                        this.countries = response.data.countries;
                        this.prefixes = this.countries.map(function (el) {
                            return el.dial_code;
                        });
                        this.prefixes = _.sortBy(_.uniqBy(this.prefixes));
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        changePhonePrefix(prefix) {
            this.phone_prefix = prefix;
        },
        getProfessions() {
            this.$http.get(api.actions.get_professions + "/" + this.generalOptions.app_id).then(
                function (response) {
                    if (typeof response.data.professions != "undefined") {

                        this.professions = response.data.professions;
                        if (this.professions.length == 1) {
                            this.selectedProfession = this.professions[0];
                        }
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },
        checkReferralCode: _.debounce(function () {
            this.referralCodeChecked = false;
            this.$http.get(api.actions.check_referral_code + "?code=" + this.referralCode).then(
                function (response) {
                    this.referralCodeValid = response.data.active;
                    this.referralCodeChecked = true;
                }.bind(this),
                function () {
                    return false;
                }
            );
        }, 500),
        changeProfession(profession) {
            this.selectedProfession = profession;
        },
        getStyle() {
            if (this.generalOptions.app_id == 2) {
                return {
                    "background-color": "#b6001f !important",
                    color: "#FFFFFF !important",
                };
            }
            return {};
        },
        getButtonStyle() {
            if (this.generalOptions.app_id == 2) {
                return {
                    "background-color": "#b6001f !important",
                    "border-color": "#b6001f !important",
                };
            }
            return {};
        },
        getParameterByName(name) {
            //eslint-disable-next-line
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(window.location.href);
            if (!results) return null;
            if (!results[2]) return "";
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },
        verifyPhoneNumber() {
            var data = {
                phone_prefix: this.phone_prefix,
                phone: this.phone,
            };

            this.phoneCheckMessage = "";

            this.$http.post(api.actions.send_phone_verify_code, data).then((response) => {
                if (response.error == true) {
                    this.phoneCheckMessage = '<div class="alert alert-danger">There is an error</div>';
                    return;
                }

                if (response.data.error == true) {
                    this.phoneCheckMessage = '<div class="alert alert-danger">' + response.data.message + "</div>";
                }

                this.phoneCheckMessage = '<div class="alert alert-success">The code has been sent</div>';
                this.confirmPhoneScreen = true;
            });
        },
        checkVerificationCode() {
            var data = {
                phone: this.phone,
                code: this.phoneCheckCode,
            };

            this.$http.post(api.actions.verify_phone_code, data).then((response) => {
                if (response.error == true) {
                    this.phoneCheckMessage = '<div class="alert alert-danger">There is an error</div>';
                    return;
                }

                if (response.data.error == true) {
                    this.phoneCheckMessage = '<div class="alert alert-danger">' + response.data.message + "</div>";
                } else {
                    this.confirmedPhone = true;
                    this.onRegister();
                }
            });
        },
        onAddressChanged(place) {
            if (!place || (place && !place.address_components)) {
                return;
            }

            this.address = place.name;

            for (let key in place.address_components) {
                let component = place.address_components[key];

                if (!component.types) {
                    continue;
                }

                if (component.types.indexOf("country") != -1) {
                    this.business_address_country = component.long_name;
                } else if (component.types.indexOf("locality") != -1) {
                    this.business_address_city = component.long_name;
                } else if (component.types.indexOf("administrative_area_level_1") != -1) {
                    this.business_address_state = component.long_name;
                }
            }
        },
        resetForm() {
            this.name = "";
            this.email = "";
            this.password = "";
            this.phone = "";
            this.zip = "";
            this.address = "";
            this.business_name = "";
            this.selectedProfession = null;
            this.selectedReferralSource = "";
            this.referralCode = "";

            // reset validation states
            this.nameError = false;
            this.emailError = false;
            this.passwordError = false;
            this.phoneError = false;
            this.zipError = false;
            this.addressError = false;
            this.selectedProfessionError = false;
            this.selectedReferralSourceError = false;

            // reset error messages
            this.nameErrorMessage = "";
            this.emailErrorMessage = "";
            this.passwordErrorMessage = "";
            this.phoneErrorMessage = "";
            this.zipErrorMessage = "";
            this.addressErrorMessage = "";
            this.selectedProfessionErrorMessage = "";
            this.selectedReferralSourceErrorMessage = "";
        }
    },
};
</script>

<style scoped></style>
